/**
 * @author Maxime Louf
 * @version 1.0.0
 *
 * @param element CSS string - La cible HTML
 * @param theme string - default = 'light' - Le thème à appliquer
 * @export {setThemeMode} - Exemple : setThemeMode('#menu', 'dark')
 */

export const setThemeMode = (element, theme = 'light') => {
    const selectors = document.querySelectorAll(element);


    if (typeof(selectors) !== 'undefined' && selectors !== null) {
        selectors.forEach(selector => {
            selector.setAttribute('data-bs-theme', theme);
        })
    }
}
